// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7776 ? "477d4af2" : chunkId) + "." + {"2242":"f238f2ab3904b9a9","7776":"f930cf9fcf477102"}[chunkId] + ".js";
};